export const TablePendingList = {
    data() {
        return {
            tableColumns: [
                {
                    title: 'Nombre Comercial',
                    type: 'text',
                    key: 'name',

                },
                {
                    title: 'Razón Social',
                    type: 'text',
                    key: 'business_name',

                },
                {
                    title: 'Correo electrónico',
                    type: 'text',
                    key: 'email',

                },
                {
                    title: 'Representante Legal',
                    type: 'text',
                    key: 'legal_representative',
                },
                {
                    title: 'Fecha Registro',
                    type: 'custom-html',
                    key: 'created_at',
                    modifier: (value) => {
                        if (value) {
                            return moment(value).format("YYYY-MM-DD HH:mm");
                        }
                    }
                },
                {
                    title: 'Estado',
                    type: 'custom-html',
                    key: 'user',
                    isVisible: true,
                    modifier: (value) => {
                        if (value) {
                            let ClassName = 'warning';
                            return `<span class="badge badge-sm badge-pill badge-${ClassName}">Pendiente</span>`;
                        }
                    }
                }
            ],
            actionObj: {
                title: 'Acciones',
                type: 'action',
            }
        }
    },
}